// Configuration centralisée pour l'API
// Priorité : API_BASE_URL > LOCAL_IP (dev) > VPS_IP > valeur par défaut
const getApiBaseUrl = () => {
    var _a, _b, _c, _d, _e;
    if (typeof process !== 'undefined' && ((_a = process.env) === null || _a === void 0 ? void 0 : _a.API_BASE_URL)) {
        return process.env.API_BASE_URL;
    }
    // En développement, utiliser LOCAL_IP si disponible
    const isDev = typeof process !== 'undefined' &&
        (((_b = process.env) === null || _b === void 0 ? void 0 : _b.NODE_ENV) === 'development' || ((_c = process.env) === null || _c === void 0 ? void 0 : _c.ENV) === 'dev');
    if (isDev && typeof process !== 'undefined' && ((_d = process.env) === null || _d === void 0 ? void 0 : _d.LOCAL_IP)) {
        return `http://${process.env.LOCAL_IP}:3000/api/v1`;
    }
    const vpsIp = typeof process !== 'undefined' && ((_e = process.env) === null || _e === void 0 ? void 0 : _e.VPS_IP)
        ? process.env.VPS_IP
        : '51.91.110.29';
    return `http://${vpsIp}:3000/api/v1`;
};
const getServerUrlFromBase = () => {
    const baseUrl = getApiBaseUrl();
    // Enlever /api/v1 pour obtenir l'URL du serveur
    return baseUrl.replace('/api/v1', '');
};
const API_BASE_URL = getApiBaseUrl();
const SERVER_URL = getServerUrlFromBase();
export const API_CONFIG = {
    // URL du serveur API (sans le préfixe /api/v1)
    SERVER_URL,
    // URL de base de l'API (avec /api/v1)
    BASE_URL: API_BASE_URL,
    // Configuration spécifique pour les applications mobiles
    MOBILE_API_URL: API_BASE_URL,
    CONTROLLER_API_URL: API_BASE_URL,
    // Configuration pour différents environnements (même URL pour l'instant)
    DEVELOPMENT: {
        SERVER_URL,
        BASE_URL: API_BASE_URL,
    },
    PRODUCTION: {
        SERVER_URL,
        BASE_URL: API_BASE_URL,
    }
};
// Fonction utilitaire pour obtenir l'URL de l'API selon l'environnement
export const getApiUrl = (environment = 'development') => {
    return API_BASE_URL;
};
// Fonction utilitaire pour obtenir l'URL du serveur selon l'environnement
export const getServerUrl = (environment = 'development') => {
    return SERVER_URL;
};
